var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column site_wrapper notfound"},[_c('img',{attrs:{"src":require("@/assets/images/errorl.svg"),"width":"30%"}}),_vm._v(" "),_c('label',{staticClass:"notff"},[_vm._v("ERROR")])])
}]

export { render, staticRenderFns }